const Form095EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInformation: "Application Information",
        confirmation: "Confirmation",
    },

    mainTitle: {
        title: "Important Notes",
        picTitle: "Personal Information Collection Statement",
    },

    importantNotesContent: {
        p1_1: "Please read the below Personal Information Collection Statement before completing this form. The provision of information is obligatory. If sufficient information is not provided, a delay in effecting the payment may be occasioned.",
        p1_b1: "For withdrawal application",
        p1_u: "correctly completed,",
        p1_b2: "payment of provident fund benefits should be made within 23 working days (or 28 working days during the period from August to September) upon receipt of the withdrawal application by the Funds Section or the applicant's last day of employment, whichever is the later.",

        p2_1: "Please read Rules 9 and 13 of “Subsidized Schools Provident Fund Rules” (Cap. 279D), in particular Rule 13(2A)",
        p2_i: "(b)",
        p2_2: ", before completing this form in order to protect your rights and benefits. You may visit the Department of Justice website",
        p2_link: "http://www.elegislation.gov.hk",
        p2_3: "for the relevant Rules.",

        p3: "If the date of Withdrawal Application is earlier than that in Paragraph 9, the date of Withdrawal Application will be taken as the termination date of account accordingly.",
        p4: "Applicant who wishes to make alterations should cross out the parts altered and append his/her signature against them. In case of any change in the information furnished in the application, the applicant is required to notify the Funds Section in writing immediately.",

        p5_1: "An applicant should submit this application to his/her school. After being certified by the headteacher/ supervisor, this application must be submitted by the school to the Funds Section of Education Bureau, the address of which is at",
        p5_bu: "Room 1517, 15 Floor, Wu Chung House, 213 Queen's Road East, Wanchai, Hong Kong.",
        p5_2: "",

        p6_1: "The Funds Section will issue acknowledgement letters to the applicant as well as his/her school within 14 working days upon receipt of the application. If the applicant has not received such letter within 14 working days, he/she should contact the Funds Section at telephone number",
        p6_b1: "2892 6222",
        p6_b2: "2892 5780",
        p6_2: "to clarify the situation.",

        p7: "If a contributor wishes to have remittance in foreign currency, he/she can select one of the followings: Australian Dollars, Canadian Dollars, Euro, Japanese Yen, New Zealand Dollars, Singapore Dollars, Swiss Francs, Thai Bahts, Sterling and US Dollars.",
    },

    iamStatement:
        "In order to process the application, I understand that (i) applicant need to have an “iAM Smart+” account; and (ii) applicant need to confirm with the approving authority of the school that they have “iAM Smart+” accounts.",

    note: {
        note1: {
            title: `1.	The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:`,
            subtitle: "Purpose of Collection",
            content1:
                "(a)	Activities relating to the processing, authentication and counter-checking of Application for Withdrawal of Subsidized Schools Provident Fund; ",
            content2:
                "(b)	Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
            content3:
                "(c)	Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
            content4:
                "(d)	Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
            content5:
                "(e)	Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audit;",
            content6:
                "(f)	Activities relating to compilation of statistics, research and Government publications; and",
            content7:
                "(g)	Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules) and the Codes of Aid.",
        },
        note2: {
            title: `2.	The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.`,
        },
        note3: {
            title: `3.	The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:- `,
            subtitle: "Classes of Transferees",
            content1:
                "(a)	other Government bureau and departments, including the Treasury, for the purposes mentioned in paragraph 1 above;",
            content2:
                "(b)	the school in which the form relates for the purposes mentioned in paragraph 1 above;",
            content3:
                "(c)	personnel, agent, service provider or organizations engaged by EDB to provide services or advice for purposes mentioned in paragraph 1 above;",
            content4:
                "(d)	where you have given your prescribed consent to such disclosure; and",
            content5:
                "(e)	where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
        },
        note4: {
            title: `4.	You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to:`,
            subtitle: "Access to Personal Data",
        },
    },

    address: {
        address1: "Accounting Officer I (Funds) 2",
        address2: "Funds Section",
        address3: "Education Bureau",
        address4:
            "Room 1517, Wu Chung House, 213 Queen's Road East, Wan Chai, Hong Kong",
    },

    applicationInformationContent: {
        label: {
            // form 095
            formTitle: "Personal Information",

            nameOfContributorEN:
                "Name of Contributor  in English (as printed on the HK Identity Card)",
            nameOfContributorCH:
                "Name of Contributor  in Chinese (as printed on the HK Identity Card)",

            hkid: "Hong Kong Identity Card No.",
            dateOfBirth: "Date of birth",
            addressEN: "Address in English",
            telNo: "Telephone No.",
            staffNo: "Staff Reference No.",

            lastSchoolEmployment: "Last school of employment",
            primaryOrSecondaryOption: {
                primary: "Primary School",
                secondary: "Seconday School",
            },
            schoolOption: {
                schoolA: "School A",
                schoolB: "School B",
                schoolC: "School C",
            },
            schoolName: "School Name",

            schoolCode: "School Code",
            lastEmploymentDate: "Last day of employment",
            lastAccountKeptOpen:
                'Last day of approved period of "Account Kept-open" (complete if applicable)',

            terminationReason: "Termination of Services",
            terminationReasonOption: {
                resignation: "by resignation",
                retirement: "on retirement",
                dismissal: "by dismissal",
                death: "on death",
                illHealth: "on ground of ill-health (Rule 13(1)(b) applicable)",
                others: "others",
            },
            pleaseState: "Please state",

            paymentOfProvident:
                "Payment of Provident Fund to be made (Correction fluid is not accepted in this column)",
            paymentOfProvidentOption: {
                byBank: "to my Current/Savings Bank Account in HK dollars stated below; the Bank's acknowledgement will be sufficient discharge in lieu of my personal acknowledgement. Any bank service charges arising from incorrect bank account information provided herein are to be borne by me and I agree that such charges are to be deducted at source from my provident fund benefits.",

                byCheque:
                    "by telegraphic transfer to me at the following bank account outside the Hong Kong Special Administrative Region; the handling charges incurred are to be deducted at source from my provident fund benefits. (Please refer to Note (7) in Important Notes and indicate one of the ten specified currencies)",
            },

            // label of by bank
            bankCode: "Bank Code",
            branchCode: "Branch Code",
            accountNo: "Account No.",
            bankName: "Bank's Name",

            // label of by cheque
            overseaAddressOrBankAccount: "Bank’s Name/Account No.",
            currency: "Currency",

            // for signing
            signingDeclare:
                "I have read the Education (Amendment) Ordinance 2013 (Amendment Ordinance) attached at Appendix and understand that the Amendment Ordinance aims to provide for protection to provident fund members, in case of bankruptcy, of their benefits in provident funds that are maintained under the Ordinance.",
            signingDeclare1:
                "I have read the Education (Amendment) Ordinance 2013 (Amendment Ordinance) attached at ",
            appendix: "Appendix",
            signingDeclare2:
                " and understand that the Amendment Ordinance aims to provide for protection to provident fund members, in case of bankruptcy, of their benefits in provident funds that are maintained under the Ordinance.",
            signing1Declare:
                "I have read paragraph 12 in Part A and Notes in Part D.",
            signing2Declare:
                "Certified that particulars as shown in para. 1, 2, 3, 6, 7, 8 & 10 above are correct.",

            sign1Name: "Name of Applicant",
            sign1Date: "Date",

            sign2Name: "Name",
            sign2Post: "Post",
            sign2PostOption: {
                schoolHead: "School Head",
                supervisor: "School Supervisor",
            },
            sign2Date: "Date",

            //school chop
            schoolChop: "School Chop",
        },
        errorMsg: {
            // test field unit
            nameOfApplicationEn: "name of applicant in English",
            nameOfApplicationCh: "name of applicant in Chinese",
            nameEN: "english name",
            nameCH: "chinese name",
            name: "name",

            addressEN: "address in english",
            accountNo: "account no.",

            // specific test message
            telNo: "Telephone no. must be exactly 8 digits",
            staffNo: "Staff reference no. must be exactly 8 digits",
            schoolCode: "School code must be exactly 4 digits",
            bankCode: "Bank code must be exactly 3 digits",
            threeMonth: "The date should be within 3-month after today",
            afterLastEmploymentDate:
                "The date should be after the last day of employment",
            atMostOneOption: "This field must be only one selection",
        },
    },
};
export default Form095EN;
